// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file brokers/v1/brokers.proto (package leficaneur.brokers.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file brokers/v1/brokers.proto.
 */
export const file_brokers_v1_brokers: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message leficaneur.brokers.v1.RegisterRequest
 */
export type RegisterRequest = Message<"leficaneur.brokers.v1.RegisterRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string confirm_password = 3;
   */
  confirmPassword: string;

  /**
   * @generated from field: string first_name = 4;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 5;
   */
  lastName: string;

  /**
   * @generated from field: string phone_number = 6;
   */
  phoneNumber: string;
};

/**
 * Describes the message leficaneur.brokers.v1.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 0);

/**
 * @generated from message leficaneur.brokers.v1.RegisterResponse
 */
export type RegisterResponse = Message<"leficaneur.brokers.v1.RegisterResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message leficaneur.brokers.v1.RegisterResponse.
 * Use `create(RegisterResponseSchema)` to create a new message.
 */
export const RegisterResponseSchema: GenMessage<RegisterResponse> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 1);

/**
 * @generated from message leficaneur.brokers.v1.LoginRequest
 */
export type LoginRequest = Message<"leficaneur.brokers.v1.LoginRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message leficaneur.brokers.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 2);

/**
 * @generated from message leficaneur.brokers.v1.LoginResponse
 */
export type LoginResponse = Message<"leficaneur.brokers.v1.LoginResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message leficaneur.brokers.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 3);

/**
 * @generated from message leficaneur.brokers.v1.Broker
 */
export type Broker = Message<"leficaneur.brokers.v1.Broker"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string hashed_password = 3;
   */
  hashedPassword: string;

  /**
   * @generated from field: string first_name = 4;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 5;
   */
  lastName: string;

  /**
   * @generated from field: string phone_number = 6;
   */
  phoneNumber: string;
};

/**
 * Describes the message leficaneur.brokers.v1.Broker.
 * Use `create(BrokerSchema)` to create a new message.
 */
export const BrokerSchema: GenMessage<Broker> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 4);

/**
 * @generated from message leficaneur.brokers.v1.VerifyTokenRequest
 */
export type VerifyTokenRequest = Message<"leficaneur.brokers.v1.VerifyTokenRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message leficaneur.brokers.v1.VerifyTokenRequest.
 * Use `create(VerifyTokenRequestSchema)` to create a new message.
 */
export const VerifyTokenRequestSchema: GenMessage<VerifyTokenRequest> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 5);

/**
 * @generated from message leficaneur.brokers.v1.VerifyTokenResponse
 */
export type VerifyTokenResponse = Message<"leficaneur.brokers.v1.VerifyTokenResponse"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: int64 user_id = 2;
   */
  userId: bigint;

  /**
   * @generated from field: string email = 3;
   */
  email: string;
};

/**
 * Describes the message leficaneur.brokers.v1.VerifyTokenResponse.
 * Use `create(VerifyTokenResponseSchema)` to create a new message.
 */
export const VerifyTokenResponseSchema: GenMessage<VerifyTokenResponse> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 6);

/**
 * @generated from message leficaneur.brokers.v1.BrokerInfoRequest
 */
export type BrokerInfoRequest = Message<"leficaneur.brokers.v1.BrokerInfoRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message leficaneur.brokers.v1.BrokerInfoRequest.
 * Use `create(BrokerInfoRequestSchema)` to create a new message.
 */
export const BrokerInfoRequestSchema: GenMessage<BrokerInfoRequest> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 7);

/**
 * @generated from message leficaneur.brokers.v1.BrokerInfoResponse
 */
export type BrokerInfoResponse = Message<"leficaneur.brokers.v1.BrokerInfoResponse"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: leficaneur.brokers.v1.Broker broker = 2;
   */
  broker?: Broker | undefined;
};

/**
 * Describes the message leficaneur.brokers.v1.BrokerInfoResponse.
 * Use `create(BrokerInfoResponseSchema)` to create a new message.
 */
export const BrokerInfoResponseSchema: GenMessage<BrokerInfoResponse> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 8);

/**
 * @generated from message leficaneur.brokers.v1.BrokerListFormsRequest
 */
export type BrokerListFormsRequest = Message<"leficaneur.brokers.v1.BrokerListFormsRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message leficaneur.brokers.v1.BrokerListFormsRequest.
 * Use `create(BrokerListFormsRequestSchema)` to create a new message.
 */
export const BrokerListFormsRequestSchema: GenMessage<BrokerListFormsRequest> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 9);

/**
 * @generated from message leficaneur.brokers.v1.FormStatus
 */
export type FormStatus = Message<"leficaneur.brokers.v1.FormStatus"> & {
  /**
   * @generated from field: leficaneur.brokers.v1.FormStatus.Status status = 1;
   */
  status: FormStatus_Status;
};

/**
 * Describes the message leficaneur.brokers.v1.FormStatus.
 * Use `create(FormStatusSchema)` to create a new message.
 */
export const FormStatusSchema: GenMessage<FormStatus> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 10);

/**
 * @generated from enum leficaneur.brokers.v1.FormStatus.Status
 */
export enum FormStatus_Status {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CANCELED = 1;
   */
  CANCELED = 1,

  /**
   * @generated from enum value: PENDING = 2;
   */
  PENDING = 2,

  /**
   * @generated from enum value: COMPLETED = 3;
   */
  COMPLETED = 3,
}

/**
 * Describes the enum leficaneur.brokers.v1.FormStatus.Status.
 */
export const FormStatus_StatusSchema: GenEnum<FormStatus_Status> = /*@__PURE__*/
  enumDesc(file_brokers_v1_brokers, 10, 0);

/**
 * @generated from message leficaneur.brokers.v1.FormSubmissionSummary
 */
export type FormSubmissionSummary = Message<"leficaneur.brokers.v1.FormSubmissionSummary"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string project_name = 2;
   */
  projectName: string;

  /**
   * @generated from field: string buyer_last_name = 3;
   */
  buyerLastName: string;

  /**
   * @generated from field: string buyer_first_name = 4;
   */
  buyerFirstName: string;

  /**
   * @generated from field: string city = 5;
   */
  city: string;

  /**
   * @generated from field: leficaneur.brokers.v1.FormStatus status = 6;
   */
  status?: FormStatus | undefined;

  /**
   * @generated from field: string share_token = 7;
   */
  shareToken: string;
};

/**
 * Describes the message leficaneur.brokers.v1.FormSubmissionSummary.
 * Use `create(FormSubmissionSummarySchema)` to create a new message.
 */
export const FormSubmissionSummarySchema: GenMessage<FormSubmissionSummary> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 11);

/**
 * @generated from message leficaneur.brokers.v1.BrokerListFormsResponse
 */
export type BrokerListFormsResponse = Message<"leficaneur.brokers.v1.BrokerListFormsResponse"> & {
  /**
   * @generated from field: repeated leficaneur.brokers.v1.FormSubmissionSummary forms = 1;
   */
  forms: FormSubmissionSummary[];
};

/**
 * Describes the message leficaneur.brokers.v1.BrokerListFormsResponse.
 * Use `create(BrokerListFormsResponseSchema)` to create a new message.
 */
export const BrokerListFormsResponseSchema: GenMessage<BrokerListFormsResponse> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 12);

/**
 * @generated from message leficaneur.brokers.v1.RecordFormViewRequest
 */
export type RecordFormViewRequest = Message<"leficaneur.brokers.v1.RecordFormViewRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 form_id = 2;
   */
  formId: bigint;
};

/**
 * Describes the message leficaneur.brokers.v1.RecordFormViewRequest.
 * Use `create(RecordFormViewRequestSchema)` to create a new message.
 */
export const RecordFormViewRequestSchema: GenMessage<RecordFormViewRequest> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 13);

/**
 * @generated from message leficaneur.brokers.v1.RecordFormViewResponse
 */
export type RecordFormViewResponse = Message<"leficaneur.brokers.v1.RecordFormViewResponse"> & {
};

/**
 * Describes the message leficaneur.brokers.v1.RecordFormViewResponse.
 * Use `create(RecordFormViewResponseSchema)` to create a new message.
 */
export const RecordFormViewResponseSchema: GenMessage<RecordFormViewResponse> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 14);

/**
 * ResendFormInvitation mails the form link to the buyers again, for the times a
 * buyer never received it or lost it. Only the broker who owns the form may.
 *
 * @generated from message leficaneur.brokers.v1.ResendFormInvitationRequest
 */
export type ResendFormInvitationRequest = Message<"leficaneur.brokers.v1.ResendFormInvitationRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 form_id = 2;
   */
  formId: bigint;
};

/**
 * Describes the message leficaneur.brokers.v1.ResendFormInvitationRequest.
 * Use `create(ResendFormInvitationRequestSchema)` to create a new message.
 */
export const ResendFormInvitationRequestSchema: GenMessage<ResendFormInvitationRequest> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 15);

/**
 * @generated from message leficaneur.brokers.v1.ResendFormInvitationResponse
 */
export type ResendFormInvitationResponse = Message<"leficaneur.brokers.v1.ResendFormInvitationResponse"> & {
  /**
   * Token of the buyers' link, so the admin can copy it when the mail bounced.
   *
   * @generated from field: string share_token = 1;
   */
  shareToken: string;

  /**
   * Buyer addresses the link was sent to.
   *
   * @generated from field: repeated string emailed_to = 2;
   */
  emailedTo: string[];

  /**
   * Buyer addresses that could not be reached.
   *
   * @generated from field: repeated string email_failures = 3;
   */
  emailFailures: string[];
};

/**
 * Describes the message leficaneur.brokers.v1.ResendFormInvitationResponse.
 * Use `create(ResendFormInvitationResponseSchema)` to create a new message.
 */
export const ResendFormInvitationResponseSchema: GenMessage<ResendFormInvitationResponse> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 16);

/**
 * @generated from message leficaneur.brokers.v1.ListRecentFormsRequest
 */
export type ListRecentFormsRequest = Message<"leficaneur.brokers.v1.ListRecentFormsRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message leficaneur.brokers.v1.ListRecentFormsRequest.
 * Use `create(ListRecentFormsRequestSchema)` to create a new message.
 */
export const ListRecentFormsRequestSchema: GenMessage<ListRecentFormsRequest> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 17);

/**
 * @generated from message leficaneur.brokers.v1.ListRecentFormsResponse
 */
export type ListRecentFormsResponse = Message<"leficaneur.brokers.v1.ListRecentFormsResponse"> & {
  /**
   * @generated from field: repeated leficaneur.brokers.v1.FormSubmissionSummary forms = 1;
   */
  forms: FormSubmissionSummary[];
};

/**
 * Describes the message leficaneur.brokers.v1.ListRecentFormsResponse.
 * Use `create(ListRecentFormsResponseSchema)` to create a new message.
 */
export const ListRecentFormsResponseSchema: GenMessage<ListRecentFormsResponse> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 18);

/**
 * @generated from message leficaneur.brokers.v1.RequestPasswordResetRequest
 */
export type RequestPasswordResetRequest = Message<"leficaneur.brokers.v1.RequestPasswordResetRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message leficaneur.brokers.v1.RequestPasswordResetRequest.
 * Use `create(RequestPasswordResetRequestSchema)` to create a new message.
 */
export const RequestPasswordResetRequestSchema: GenMessage<RequestPasswordResetRequest> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 19);

/**
 * Deliberately empty: the response is the same whether or not the address has
 * an account, so it cannot be used to discover which emails are registered.
 *
 * @generated from message leficaneur.brokers.v1.RequestPasswordResetResponse
 */
export type RequestPasswordResetResponse = Message<"leficaneur.brokers.v1.RequestPasswordResetResponse"> & {
};

/**
 * Describes the message leficaneur.brokers.v1.RequestPasswordResetResponse.
 * Use `create(RequestPasswordResetResponseSchema)` to create a new message.
 */
export const RequestPasswordResetResponseSchema: GenMessage<RequestPasswordResetResponse> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 20);

/**
 * @generated from message leficaneur.brokers.v1.ResetPasswordRequest
 */
export type ResetPasswordRequest = Message<"leficaneur.brokers.v1.ResetPasswordRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string confirm_password = 3;
   */
  confirmPassword: string;
};

/**
 * Describes the message leficaneur.brokers.v1.ResetPasswordRequest.
 * Use `create(ResetPasswordRequestSchema)` to create a new message.
 */
export const ResetPasswordRequestSchema: GenMessage<ResetPasswordRequest> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 21);

/**
 * @generated from message leficaneur.brokers.v1.ResetPasswordResponse
 */
export type ResetPasswordResponse = Message<"leficaneur.brokers.v1.ResetPasswordResponse"> & {
};

/**
 * Describes the message leficaneur.brokers.v1.ResetPasswordResponse.
 * Use `create(ResetPasswordResponseSchema)` to create a new message.
 */
export const ResetPasswordResponseSchema: GenMessage<ResetPasswordResponse> = /*@__PURE__*/
  messageDesc(file_brokers_v1_brokers, 22);

/**
 * @generated from service leficaneur.brokers.v1.BrokersService
 */
export const BrokersService: GenService<{
  /**
   * @generated from rpc leficaneur.brokers.v1.BrokersService.Register
   */
  register: {
    methodKind: "unary";
    input: typeof RegisterRequestSchema;
    output: typeof RegisterResponseSchema;
  },
  /**
   * @generated from rpc leficaneur.brokers.v1.BrokersService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc leficaneur.brokers.v1.BrokersService.VerifyToken
   */
  verifyToken: {
    methodKind: "unary";
    input: typeof VerifyTokenRequestSchema;
    output: typeof VerifyTokenResponseSchema;
  },
  /**
   * @generated from rpc leficaneur.brokers.v1.BrokersService.BrokerInfo
   */
  brokerInfo: {
    methodKind: "unary";
    input: typeof BrokerInfoRequestSchema;
    output: typeof BrokerInfoResponseSchema;
  },
  /**
   * @generated from rpc leficaneur.brokers.v1.BrokersService.BrokerListForms
   */
  brokerListForms: {
    methodKind: "unary";
    input: typeof BrokerListFormsRequestSchema;
    output: typeof BrokerListFormsResponseSchema;
  },
  /**
   * @generated from rpc leficaneur.brokers.v1.BrokersService.RecordFormView
   */
  recordFormView: {
    methodKind: "unary";
    input: typeof RecordFormViewRequestSchema;
    output: typeof RecordFormViewResponseSchema;
  },
  /**
   * @generated from rpc leficaneur.brokers.v1.BrokersService.ListRecentForms
   */
  listRecentForms: {
    methodKind: "unary";
    input: typeof ListRecentFormsRequestSchema;
    output: typeof ListRecentFormsResponseSchema;
  },
  /**
   * @generated from rpc leficaneur.brokers.v1.BrokersService.RequestPasswordReset
   */
  requestPasswordReset: {
    methodKind: "unary";
    input: typeof RequestPasswordResetRequestSchema;
    output: typeof RequestPasswordResetResponseSchema;
  },
  /**
   * @generated from rpc leficaneur.brokers.v1.BrokersService.ResetPassword
   */
  resetPassword: {
    methodKind: "unary";
    input: typeof ResetPasswordRequestSchema;
    output: typeof ResetPasswordResponseSchema;
  },
  /**
   * @generated from rpc leficaneur.brokers.v1.BrokersService.ResendFormInvitation
   */
  resendFormInvitation: {
    methodKind: "unary";
    input: typeof ResendFormInvitationRequestSchema;
    output: typeof ResendFormInvitationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_brokers_v1_brokers, 0);

